import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationCampaign,
  BackendMutationPauseContinuousOptimizationCampaignArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation PauseCOCampaign($id: ID!) {
    pauseContinuousOptimizationCampaign(id: $id) {
      id
      status
    }
  }
`;

type Variables = BackendMutationPauseContinuousOptimizationCampaignArgs;
type Result = Pick<BackendContinuousOptimizationCampaign, 'id' | 'status'>;

export const pauseCOCampaign = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
